import { createStore } from 'satcheljs';
import { FeedbackViewState } from './schema/FeedbackViewState';
import { InlineFeedbackDialogState } from './schema/InlineFeedbackDialogState';
import { ObservableMap } from 'mobx';
import { FeedbackRibbonStore } from './schema/FeedbackRibbonStore';
import { FeedbackRibbonState } from './schema/FeedbackRibbonState';

var initialFeedbackViewState: FeedbackViewState = {
    subjectArea: '',
    emailAddresses: ['owareactmail@service.microsoft.com'],
    subject: '',
    message: '',
    classification: '',
    screenshotBlob: null,
    screenshotFileBase64: null,
};

export var store = createStore<FeedbackViewState>('feedbackViewState', initialFeedbackViewState)();

export let inlineFeedbackDialogStore = createStore<InlineFeedbackDialogState>(
    'inlineFeedbackDialogStore',
    {
        showThankyouDialog: false,
        showInlineFeedbackDialog: false,
        inlineFeedbackResponseText: '',
        inlineFeedbackResponseCategories: [],
        isContentDonated: false,
        isSubmitDisabled: true,
    }
);

var initialFeedbackRibbonStore: FeedbackRibbonStore = {
    mountedRibbons: new ObservableMap<string, FeedbackRibbonState>(),
};

export let feedbackRibbonStore = createStore<FeedbackRibbonStore>(
    'feedbackRibbonStore',
    initialFeedbackRibbonStore
)();
